import gcashLogo from 'assets/images/gcash-logo.png';
import { PartnerNameEnum } from 'shared/enums/partner-name-enum';
import boostLogo from 'assets/images/boost-logo-small.png';

export const getPartnerLogo = (partnerName: PartnerNameEnum) => {
  switch (partnerName) {
    case PartnerNameEnum.LENDING:
    case PartnerNameEnum.GCASH_LENDING:
    case PartnerNameEnum.GCASH_MERCHANTS:
      return gcashLogo;
    default:
      return boostLogo;
  }
};
